import React, { useEffect, useState, useContext, useRef } from 'react'
import styles from './Laboral.module.css'
import Subtitle from '../Subtitle'
import GeneralContext from '../../context/GeneralContext'

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

const Laboral = ({ asegurado, contratante, state, setState }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const [girosEmpresa, setGirosEmpresa] = useState([])
    const [stateGirosEmpresa, setStateGirosEmpresa] = useState({})
    const giroRef = useRef()
    const [cargos, setCargos] = useState([])
    const [ocupaciones, setOcupaciones] = useState([])
    const [stateOcupaciones, setStateOcupaciones] = useState({})
    const ocupacionesRef = useRef()
    const [tipoLabores, setTipoLabores] = useState([])

    useEffect(() => {
        const cargarCombos = () => {
            setCargos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 2))
            setTipoLabores(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 3))
            setGirosEmpresa(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 7))
            setOcupaciones(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 9))
        }

        if (contratante && contratante.laboral === null) {
            giroRef.current.value = null
            ocupacionesRef.current.value = null
        }

        cargarCombos()
    }, [contratante && contratante.laboral])

    const handleChangeCombo = (event, campo) => {
        let codigo = event.target.value
        let descripcion = event.target[event.target.selectedIndex].text
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    laboral: {
                        ...state.contratante.laboral,
                        [campo]: {
                            codigo: parseInt(codigo),
                            descripcion: descripcion
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })
    }

    const handleChangeEmpleador = (e, campo, tipo) => {
        let valor = e.target.value
        if (tipo === 'a') {
            setState((state) => {
                return {
                    ...state,
                    asegurado: {
                        ...state.asegurado,
                        laboral: {
                            ...state.asegurado.laboral,
                            [campo]: valor
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: true
                    }
                }
            })
        } else {
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...state.contratante,
                        laboral: {
                            ...state.contratante.laboral,
                            [campo]: valor
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: true
                    }
                }
            })
        }
    }

    const handleChangeNumerico2 = (e, campo) => {
        let value = e.target.value
        const re = /^[0-9\b.,]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setState((state) => {
                return {
                    ...state,
                    asegurado: {
                        ...state.asegurado,
                        laboral: {
                            ...state.asegurado.laboral,
                            [campo]: Funciones.cantidadStringToFloat(value)
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: true
                    }
                }
            })
        }
    }
    const handleChangeNumerico3 = (e, campo) => {
        let value = e.target.value
        const re = /^[0-9\b.,]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...state.contratante,
                        laboral: {
                            ...state.contratante.laboral,
                            [campo]: Funciones.cantidadStringToFloat(value)
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: true
                    }
                }
            })
        }
    }

    const formatNumber = (value) => {
        const rex = /(^\d{2})|(\d{1,3})(?=\d{1,3}|$)/g
        const val = value.replace(/^0+|\.|,/g, "")
        let res = ''

        if (val.length) {
            res = Array.prototype.reduce.call(val, (p, c) => c + p)            // reverse the pure numbers string
                .match(rex)                                            // get groups in array
                .reduce((p, c, i) => i - 1 ? p + "," + c : p + "." + c); // insert (.) and (,) accordingly
            res += /\.|,/.test(res) ? "" : ".0";                              // test if res has (.) or (,) in it
            value = Array.prototype.reduce.call(res, (p, c) => c + p);    // reverse the string and display
        }
        return value
    }

    ///// actualizar valor giro
    const handleChangeGiro = (event) => {
        if (event.target.value.length > 2) {
            let giroFilter = girosEmpresa.filter(giro => giro.valor.toUpperCase().indexOf(event.target.value.toUpperCase()) >= 0)
            setStateGirosEmpresa({
                ...stateGirosEmpresa,
                descripcion: event.target.value,
                verGiros: true,
                giroFilter: giroFilter
            })
        } else {
            setStateGirosEmpresa({
                ...stateGirosEmpresa,
                descripcion: '',
                verGiros: false,
                giroFilter: []
            })
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...state.contratante,
                        laboral: {
                            ...state.contratante.laboral,
                            giro: null
                        }
                    }
                }
            })
        }
    }
    const handleGiroClick = (giro) => {
        setStateGirosEmpresa({
            ...stateGirosEmpresa,
            descripcion: giro.valor,
            giro: giro,
            verGiros: false,
            errorSeleccionandoGiro: false
        })
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    laboral: {
                        ...state.contratante.laboral,
                        giro: {
                            codigo: giro.id,
                            descripcion: giro.valor
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    giro: true
                }
            }
        })
        giroRef.current.value = giro.valor
    }

    const handleChangeOcupacion = (event) => {
        if (event.target.value.length > 2) {
            let ocupacionFilter = ocupaciones.filter(ocupacion => ocupacion.valor.toUpperCase().indexOf(event.target.value.toUpperCase()) >= 0)
            setStateOcupaciones({
                ...stateOcupaciones,
                descripcion: event.target.value,
                verOcupaciones: true,
                ocupacionFilter: ocupacionFilter
            })
        } else {
            setStateOcupaciones({
                ...stateOcupaciones,
                descripcion: '',
                verOcupaciones: false,
                ocupacionFilter: []
            })
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...state.contratante,
                        laboral: {
                            ...state.contratante.laboral,
                            ocupacion: null
                        }
                    }
                }
            })
        }
    }
    const handleOcupacionClick = (ocupacion) => {
        setStateOcupaciones({
            ...stateOcupaciones,
            descripcion: ocupacion.valor,
            ocupacion: ocupacion,
            verOcupaciones: false,
            errorSeleccionandoOcupacion: false
        })
        setState((state) => {
            return {
                ...state,
                contratante: {
                    ...state.contratante,
                    laboral: {
                        ...state.contratante.laboral,
                        ocupacion: {
                            codigo: ocupacion.id,
                            descripcion: ocupacion.valor
                        }
                    }
                },
                campoValidado: {
                    ...state.campoValidado,
                    ocupacion: true
                }
            }
        })
        ocupacionesRef.current.value = ocupacion.valor
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    let contenido = null
    if (asegurado) {//TODO: Pendiente hacer cambios para Asegurado
        contenido = <div className={styles['areadatosprospecto']}>
            <Subtitle
                sname="Laboral"
                smostrar="false"
            />
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area75']}>
                    <label>Empleador / Empresa&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.empleadorEmpresa ? styles['logerror'] : null}
                        value={asegurado.laboral.empleadorEmpresa || ''}
                        onChange={(e) => handleChangeEmpleador(e, 'empleadorEmpresa', 'a')}
                        disabled={Deshabilitar() !== true ? false : true}
                        maxLength={130}
                        style={{ textTransform: "capitalize" }}
                    />
                    {!state.campoValidado.empleadorEmpresa &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMPLEADOR_EMPRESA}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Ingreso anual en S/ &nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input
                        type='text'
                        className={!state.campoValidado.ingresoAnual ? `${styles['logerror']} ${styles['tipoLabores']}` : styles['tipoLabores']}
                        value={Funciones.formatoMonedaLaboral(asegurado.laboral.ingresoAnual)}
                        options={{
                            numeral: false,
                            numeralThousandsGroupStyle: 'thousand'
                        }}
                        maxLength={9} //CMUNAYLLA: se cambia por la longitud pedida
                        onChange={(e) => handleChangeNumerico2(e, 'ingresoAnual')}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    {!state.campoValidado.ingresoAnual &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_INGRESO_ANUAL}</span>
                    }
                </div>
            </div>
        </div>
    } else if (contratante) {
        contenido = <div className={styles['areadatosprospecto']}>
            <Subtitle
                sname="Laboral"
                smostrar="false"
            />
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area50']}>
                    <label>Empleador / Empresa&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.empleadorEmpresa ? styles['logerror'] : null}
                        value={(contratante.laboral && contratante.laboral.empleadorEmpresa) || ''}
                        onChange={(e) => handleChangeEmpleador(e, 'empleadorEmpresa', 'c')}
                        disabled={Deshabilitar() !== true ? false : true} 
                        maxLength={130}
                        style={{ textTransform: "capitalize" }}
                    />
                    {!state.campoValidado.empleadorEmpresa &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMPLEADOR_EMPRESA}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Giro&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.giro ? `${styles['logerror']} ${styles['cargo']}` : styles['cargo']}
                        defaultValue={(contratante.laboral && contratante.laboral.giro) ? contratante.laboral.giro.descripcion : ''}
                        onChange={handleChangeGiro}
                        disabled={Deshabilitar() !== true ? false : true}
                        ref={giroRef}
                    />
                    <div className={styles['autocompletar']}>
                        <div id="myInputautocomplete-list" className={styles['autocomplete-items']}>
                            {stateGirosEmpresa.verGiros
                                ? stateGirosEmpresa.giroFilter.map(giro => (
                                    <div key={giro.id} onClick={event => handleGiroClick(giro)}>
                                        {giro.valor.substring(0, giro.valor.toUpperCase().indexOf(stateGirosEmpresa.descripcion.toUpperCase()))}
                                        <strong>{giro.valor.substring(giro.valor.toUpperCase().indexOf(stateGirosEmpresa.descripcion.toUpperCase()),
                                            giro.valor.toUpperCase().indexOf(stateGirosEmpresa.descripcion.toUpperCase()) + stateGirosEmpresa.descripcion.length)}
                                        </strong>
                                        {giro.valor.substring(
                                            giro.valor.toUpperCase().indexOf(stateGirosEmpresa.descripcion.toUpperCase()) + stateGirosEmpresa.descripcion.length,
                                            giro.valor.length
                                        )}
                                    </div>
                                ))
                                : null}
                        </div>
                    </div>
                    {!state.campoValidado.giro &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_GIRO}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Cargo&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <select
                        className={!state.campoValidado.cargo ? `${styles['logerror']} ${styles['cargo']}` : styles['cargo']}
                        value={(contratante.laboral && contratante.laboral.cargo) ? contratante.laboral.cargo.codigo : ''}
                        onChange={(e) => handleChangeCombo(e, 'cargo')}
                        disabled={Deshabilitar() !== true ? false : true}>
                        <option value={0}>Seleccione</option>
                        {cargos && cargos.length > 0 && cargos.map(cargo => (
                            <option key={cargo.id} value={cargo.id}>
                                {cargo.valor}
                            </option>
                        ))}
                    </select>
                    {!state.campoValidado.cargo &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_CARGO}</span>
                    }
                </div>
            </div>
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area50']}>
                    <label>Ocupación&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidado.ocupacion ? `${styles['logerror']} ${styles['ocupacion']}` : styles['ocupacion']}
                        defaultValue={(contratante.laboral && contratante.laboral.ocupacion) ? contratante.laboral.ocupacion.descripcion : ''}
                        onChange={handleChangeOcupacion}
                        ref={ocupacionesRef}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    <div className={styles['autocompletar']}>
                        <div id="myInputautocomplete-list2" className={styles['autocomplete-items2']}>
                            {stateOcupaciones.verOcupaciones
                                ? stateOcupaciones.ocupacionFilter.map(ocupacion => (
                                    <div key={ocupacion.id} onClick={event => handleOcupacionClick(ocupacion)}>
                                        {ocupacion.valor.substring(0, ocupacion.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()))}
                                        <strong>{ocupacion.valor.substring(ocupacion.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()),
                                            ocupacion.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()) + stateOcupaciones.descripcion.length)}
                                        </strong>
                                        {ocupacion.valor.substring(
                                            ocupacion.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()) + stateOcupaciones.descripcion.length,
                                            ocupacion.valor.length
                                        )}
                                    </div>
                                ))
                                : null}
                        </div>
                    </div>
                    {!state.campoValidado.ocupacion &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_OCUPACION}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Tipo de labores&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <select
                        className={!state.campoValidado.tipoLabores ? `${styles['logerror']} ${styles['tipoLabores']}` : styles['tipoLabores']}
                        value={(contratante.laboral && contratante.laboral.tipoLabores) ? contratante.laboral.tipoLabores.codigo : ''}
                        onChange={(e) => handleChangeCombo(e, 'tipoLabores')}
                        disabled={Deshabilitar() !== true ? false : true}>
                        <option value={0}>Seleccione</option>
                        {tipoLabores && tipoLabores.length > 0 && tipoLabores.map(tipoLabor => (
                            <option key={tipoLabor.id} value={tipoLabor.id}>
                                {tipoLabor.valor}
                            </option>
                        ))}
                    </select>
                    {!state.campoValidado.tipoLabores &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_TIPO_LABORES}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Ingreso anual en S/ &nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input
                        className={!state.campoValidado.ingresoAnual ? `${styles['logerror']} ${styles['tipoLabores']}` : styles['tipoLabores']}
                        type='text'
                        value={contratante.laboral ? Funciones.formatoMonedaLaboral(contratante.laboral.ingresoAnual) : ''}
                        options={{
                            numeral: false,
                            numeralThousandsGroupStyle: 'thousand'
                        }}
                        maxLength={9} //CMUNAYLLA: se cambia por la longitud pedida 
                        disabled={Deshabilitar() !== true ? false : true}
                        onChange={(e) => handleChangeNumerico3(e, 'ingresoAnual')} />
                    {!state.campoValidado.ingresoAnual &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_INGRESO_ANUAL}</span>
                    }
                </div>
            </div>
        </div>
    }

    return contenido
}

export default Laboral